import { ProductCard } from "devferx-product-card";
import { MyLabel } from "devferx-my-storybook";
import "./App.css";

const product = {
  id: "1",
  title: "Coffee Mug - Card",
  img: "./coffee-mug.png",
};

function App() {
  return (
    <div className="App App-header">
      <MyLabel label="Custom Product Card" size="h1" fontColor="white" />
      <div style={{ height: "24px" }}></div>
      <ProductCard
        product={product}
        initialValues={{
          count: 4,
          maxCount: 10,
        }}
      >
        {({ count, isMaxCountReached, maxCount, reset, increaseBy }) => (
          <>
            <ProductCard.Image />
            <ProductCard.Title />
            <ProductCard.Buttons />
          </>
        )}
      </ProductCard>
    </div>
  );
}

export default App;
